import type { Game } from '@/catalog/types'
import { cn } from '@/lib/cn'
import { GameCard } from './GameCard'

export function GameGrid({ games, className }: { games: Game[]; className?: string }) {
  return (
    <ul className={cn('grid grid-cols-2 gap-x-4 gap-y-6 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5', className)}>
      {games.map((game) => (
        <li key={game.id} className="render-lazy">
          <GameCard game={game} />
        </li>
      ))}
    </ul>
  )
}
